/* eslint-disable */
import { AUTH_FORGOT_PASSWORD_CLICKED } from '../Auth.types';

/**
 * Auth action for forgot password action
 * @returns {ActionCreator<FromPromise<AuthEntity, Error, {}, AUTH_FORGOT_PASSWORD_CLICKED>>} The created `Action`
 */
const authForgotPassword = () => ({ fromPayload }) => {
  return fromPayload(null, {}, AUTH_FORGOT_PASSWORD_CLICKED);
};

export default authForgotPassword;
